module.exports = __webpack_public_path__ + "img/530b16ebc8d155fc.png";